import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const PAGE_STYLES = `
.lead-profile-page {
  background: #F5F6F8;
  height: calc(100vh - 45px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  font-family: Inter, system-ui, sans-serif;
}
.lead-profile-page .lp-content {
  width: 100%;
  padding: 16px 2vw 40px;
  margin: 0;
  box-sizing: border-box;
}
.lead-profile-page .lp-grid {
  display: grid;
  grid-template-columns: 3fr 7fr;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
}
.lead-profile-page .lp-grid > div {
  min-width: 0;
}
@media (max-width: 992px) {
  .lead-profile-page .lp-grid {
    grid-template-columns: 1fr;
  }
}
.lead-profile-page .lp-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 0 14px;
}
.lead-profile-page .lp-back-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  background: #fff;
  color: #374151;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
}
.lead-profile-page .lp-back-btn:hover {
  background: #F3EEFA;
  color: #663399;
  border-color: #D9C9EF;
}
.lead-profile-page .lp-crumb {
  font-size: 12px;
  color: #6B7280;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  font-weight: 600;
}
.lead-profile-page .lp-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin-top: 2px;
}
.lead-profile-page .lp-status-pill {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.lead-profile-page .lp-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 31, 51, 0.06), 0 1px 2px rgba(0, 31, 51, 0.04);
  border: 1px solid #EEF0F4;
  padding: 18px 20px;
  margin-bottom: 16px;
  overflow: hidden;
}
.lead-profile-page .lp-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #6B7280;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  margin: 0 0 12px;
}
.lead-profile-page .lp-card-title .lp-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #663399;
}

/* === Neutralize child component chrome === */
.lead-profile-page .spWrapper {
  height: auto !important;
  box-shadow: none !important;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
}
.lead-profile-page .ProgressBar {
  margin: 0 !important;
  padding: 8px 0;
}
.lead-profile-page .lead-remarks-new {
  margin: 0 !important;
  height: 420px !important;
  min-height: 0 !important;
  max-height: 420px !important;
  overflow-y: auto !important;
  padding: 0 !important;
}
.lead-profile-page .duplicatesContainer {
  margin: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;
  background: transparent !important;
}
.lead-profile-page .duplicate-table {
  margin-bottom: 0;
}

/* Tidy StudentProfile internals */
.lead-profile-page .spContent31 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid #F3F4F6;
  margin: 0 !important;
}
.lead-profile-page .spContent31:last-child {
  border-bottom: none;
}
.lead-profile-page .spContent32 {
  color: #6B7280;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.2px;
}
.lead-profile-page .spContent33 {
  color: #111827;
  font-size: 13px;
  font-weight: 500;
  text-align: right;
  word-break: break-word;
}
.lead-profile-page .spContent01 {
  background: linear-gradient(135deg, #7C3AED 0%, #663399 100%) !important;
  color: #fff !important;
}
.lead-profile-page .spContent02 {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  text-transform: capitalize;
}
.lead-profile-page .spContent03 {
  color: #6B7280;
  font-size: 13px;
  margin-top: 4px;
}
.lead-profile-page .spContent1 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #F3F4F6;
  font-size: 12px;
  color: #4B5563;
  margin: 12px auto 0;
}
.lead-profile-page .spContent2 {
  display: none;
}
.lead-profile-page .spContent4 {
  border-top: 1px solid #F3F4F6;
  padding-top: 14px;
  margin-top: 14px;
}
`;

const statusStyle = (status) => {
  switch (status) {
    case "admission-taken":
      return { color: "#047857", background: "#ECFDF5", border: "1px solid #A7F3D0", dot: "#10B981" };
    case "in-process":
      return { color: "#B45309", background: "#FFFBEB", border: "1px solid #FDE68A", dot: "#F59E0B" };
    case "not-interested":
    case "not-eligible":
      return { color: "#B91C1C", background: "#FEF2F2", border: "1px solid #FECACA", dot: "#EF4444" };
    default:
      return { color: "#4B5563", background: "#F3F4F6", border: "1px solid #E5E7EB", dot: "#9CA3AF" };
  }
};

const formatLabel = (raw) => {
  if (!raw) return "Lead";
  return raw
    .split("-")
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join(" ");
};

export const LeadProfileShell = ({
  crumb = "Lead Profile",
  name,
  status,
  onBack,
  children,
}) => {
  const st = statusStyle(status || "none");
  const displayName = name
    ? name.replace(/\b\w/g, (c) => c.toUpperCase())
    : "Loading…";

  return (
    <>
      <style>{PAGE_STYLES}</style>
      <div className="lead-profile-page" style={{marginTop:"45px"}}>
        <div className="lp-content">
          <div className="lp-header">
            <button
              type="button"
              className="lp-back-btn"
              onClick={onBack}
              title="Back"
              aria-label="Back"
            >
              <ArrowBackIosNewIcon style={{ fontSize: "16px" }} />
            </button>
            <div>
              <div className="lp-crumb">{crumb}</div>
              <div className="lp-title">{displayName}</div>
            </div>
            <span
              className="lp-status-pill"
              style={{
                color: st.color,
                background: st.background,
                border: st.border,
              }}
            >
              <span
                style={{
                  width: "6px",
                  height: "6px",
                  borderRadius: "50%",
                  background: st.dot,
                }}
              />
              {formatLabel(status || "none")}
            </span>
          </div>
          {children}
        </div>
      </div>
    </>
  );
};

export const LeadProfileCard = ({ title, children, style }) => (
  <div className="lp-card" style={style}>
    {title && (
      <div className="lp-card-title">
        <span className="lp-dot" />
        {title}
      </div>
    )}
    {children}
  </div>
);

export default LeadProfileShell;
